import {
  B2bIndividualOperationInitiatorValues,
  B2bIndividualOperationTypeValues,
} from '@Common/types/bo/b2b/individual_operations';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const b2bIndividualOperationInitiatorChoices = makeChoicesCommon<
  (typeof B2bIndividualOperationInitiatorValues)[number]
>()({
  backoffice: 'resources.bo_common.b2b.individual_operations.initiator.backoffice',
  user: 'resources.bo_common.b2b.individual_operations.initiator.user',
});

export const b2bIndividualOperationTypeChoices = makeChoicesCommon<
  (typeof B2bIndividualOperationTypeValues)[number]
>()({
  employee_voluntary_deposit:
    'resources.bo_common.b2b.individual_operations.type.employee_voluntary_deposit',
  company_voluntary_deposit:
    'resources.bo_common.b2b.individual_operations.type.company_voluntary_deposit',
  arbitrage: 'resources.bo_common.b2b.individual_operations.type.arbitrage',
  collective_arbitrage: 'resources.bo_common.b2b.individual_operations.type.collective_arbitrage',
  rebalancing: 'resources.bo_common.b2b.individual_operations.type.rebalancing',
  withdrawal: 'resources.bo_common.b2b.individual_operations.type.withdrawal',
  transfer_in: 'resources.bo_common.b2b.individual_operations.type.transfer_in',
  transfer_out: 'resources.bo_common.b2b.individual_operations.type.transfer_out',
  participation: 'resources.bo_common.b2b.individual_operations.type.participation',
  profit_sharing: 'resources.bo_common.b2b.individual_operations.type.profit_sharing',
  value_sharing_bonus: 'resources.bo_common.b2b.individual_operations.type.value_sharing_bonus',
  unused_vacation_days: 'resources.bo_common.b2b.individual_operations.type.unused_vacation_days',
  voluntary_deposit_campaign:
    'resources.bo_common.b2b.individual_operations.type.voluntary_deposit_campaign',
  matching_contribution: 'resources.bo_common.b2b.individual_operations.type.matching_contribution',
  corporate_action: 'resources.bo_common.b2b.individual_operations.type.corporate_action',
  ccb_matured_election: 'resources.bo_common.b2b.individual_operations.type.ccb_matured_election',
  withdrawal_at_maturity:
    'resources.bo_common.b2b.individual_operations.type.withdrawal_at_maturity',
  capital_increase: 'resources.bo_common.b2b.individual_operations.type.capital_increase',
});
